import React, { useState } from "react";
import cn from "classnames";
import styles from "./Workouts.module.sass";
import ScrollParallax from "../../../components/ScrollParallax";
import Icon from "../../../components/Icon";

// Fonctionnalités d'extraction de données
const faqItems = [
  {
    id: 1,
    title: "Extraction simplifiée",
    content: "Extrayez toutes vos données en quelques clics grâce à nos dashboards pré-configurés. Formats multiples disponibles pour tous vos besoins.",
    details: [
      "Export PDF, Excel, CSV",
      "Données certifiées",
      "Extraction en un clic",
      "Formats prêts à l'emploi"
    ]
  },
  {
    id: 2,
    title: "Consultation mobile",
    content: "Consultez vos dashboards depuis n'importe quel appareil. Interface optimisée pour smartphone et tablette avec données temps réel.",
    details: [
      "Compatible tous appareils",
      "Données temps réel", 
      "Interface responsive",
      "Accès sécurisé"
    ]
  },
  {
    id: 3,
    title: "Données actualisées",
    content: "Vos dashboards se mettent à jour automatiquement avec les dernières données de votre centre. Aucune configuration nécessaire.",
    details: [
      "Mise à jour automatique",
      "Données en temps réel",
      "Aucune maintenance",
      "Toujours à jour"
    ]
  },
];

const ExportEmargement = () => {
  const [activeItem, setActiveItem] = useState(null);

  const toggleItem = (id) => {
    setActiveItem(activeItem === id ? null : id);
  };

  return (
    <div className={styles.section}>
      <div className={cn("container", styles.container)}>
        <div className={styles.content}>
          {/* Côté gauche - Galerie d'images */}
          <div className={styles.leftContent}>
            <div className={styles.gallery}>
              {/* Image principale au centre */}
              <div className={styles.mainImage}>
                <div className={styles.imageBackground}>
                  <ScrollParallax animateIn="fadeInUp" offset={200}>
                    <img
                      src="/images/content/export-illustration.svg"
                      alt="Interface d'export des feuilles"
                      className={styles.centralImage}
                    />
                  </ScrollParallax>
                </div>
              </div>
              
              {/* Éléments flottants autour */}
              <ScrollParallax 
                className={styles.floatingElement} 
                animateIn="fadeInLeft" 
                offset={300}
                style={{
                  position: 'absolute',
                  top: '10%',
                  left: '5%',
                  zIndex: 3
                }}
              >
                <img
                  src="/images/content/export-email.svg"
                  alt="Export par email"
                  className={styles.floatingMedium}
                />
              </ScrollParallax>
              
              <ScrollParallax 
                className={styles.floatingElement} 
                animateIn="fadeInRight" 
                offset={500}
                style={{
                  position: 'absolute',
                  bottom: '-10%',
                  right: '5%',
                  zIndex: 4
                }}
              >
                <img
                  src="/images/content/export-pdf.svg"
                  alt="Export PDF"
                  className={styles.floatingLarge}
                />
              </ScrollParallax>
            </div>
          </div>

          {/* Côté droit - Texte et FAQ */}
          <div className={styles.rightContent}>
            <h2 className={cn("h2", styles.title)}>
            Dashboards et extraction de données
            </h2>
            <div className={styles.info}>
              Pilotez votre centre avec des dashboards pré-configurés et extrayez vos données facilement. Tout est prêt à l'emploi pour simplifier votre gestion quotidienne.
            </div>
            
            <div className={styles.faqList}>
              {faqItems.map((item) => (
                <ScrollParallax key={item.id} className={styles.faqItem}>
                  <div
                    className={cn(styles.faqHead, { [styles.active]: activeItem === item.id })}
                    onClick={() => toggleItem(item.id)}
                  >
                    <div className={styles.faqTitle}>
                      <span className={styles.questionNumber}>
                        {item.id.toString().padStart(2, '0')}.
                      </span>
                      {item.title}
                    </div>
                    <div className={styles.faqArrow}>
                      <Icon name="arrow-bottom" size="10" />
                    </div>
                  </div>
                  <div className={cn(styles.faqBody, { [styles.visible]: activeItem === item.id })}>
                    <div className={styles.faqContent}>
                      <p>{item.content}</p>
                      {item.details && (
                        <ul className={styles.detailsList}>
                          {item.details.map((detail, index) => (
                            <li key={index} className={styles.detailItem}>
                              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" className={styles.checkIcon}>
                                <path d="M13.5 4.5L6 12L2.5 8.5" stroke="#39CD54" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                              </svg>
                              {detail}
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                </ScrollParallax>
              ))}
            </div>
          </div>


        </div>
      </div>
    </div>
  );
};

export default ExportEmargement;
